var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3538 6.35372L8.35375 11.3537C8.30732 11.4002 8.25217 11.4371 8.19147 11.4623C8.13077 11.4874 8.06571 11.5004 8 11.5004C7.9343 11.5004 7.86923 11.4874 7.80853 11.4623C7.74783 11.4371 7.69269 11.4002 7.64625 11.3537L2.64625 6.35372C2.55243 6.2599 2.49973 6.13265 2.49973 5.99997C2.49973 5.86729 2.55243 5.74004 2.64625 5.64622C2.74007 5.5524 2.86732 5.49969 3 5.49969C3.13269 5.49969 3.25993 5.5524 3.35375 5.64622L8 10.2931L12.6463 5.64622C12.6927 5.59977 12.7479 5.56292 12.8086 5.53778C12.8693 5.51263 12.9343 5.49969 13 5.49969C13.0657 5.49969 13.1308 5.51263 13.1915 5.53778C13.2521 5.56292 13.3073 5.59977 13.3538 5.64622C13.4002 5.69268 13.4371 5.74783 13.4622 5.80852C13.4873 5.86922 13.5003 5.93428 13.5003 5.99997C13.5003 6.06567 13.4873 6.13072 13.4622 6.19142C13.4371 6.25212 13.4002 6.30727 13.3538 6.35372Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownLogoWhite);
export default __webpack_public_path__ + "static/media/downLogoWhite.1df81312a1963b1a123a8f8461e4dd99.svg";
export { ForwardRef as ReactComponent };